const Statistic = () => import('@/views/main/voice/statistic/Statistic.vue')
export default {
  path: '/main/voice/statistic',
  name: 'Statistic',
  component: Statistic,
  children: []
}
